import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CustomerSpecificSettingsPage } from '@/areas/settings/manufacturing/OrganizationSettings/CustomerSpecificSettings';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/settings/_menu/organization/customer-portal/customer-specific-settings',
)({
    staticData: {
        access: { permissions: canViewCustomerPortalSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CustomerSpecificSettingsPage />;
}
